import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import AppointmentForm from '../../Components/Appointment/AppointmentForm';
import { bindActionCreators } from "redux";
import commonActionsImp from "../../Actions/commonActions";
import appointmentActionsImp from '../../Actions/appointmentActions';

function AppointmentFormContainer({isCreation, callback, appointmentFormWidth, hideButtons, isMyAppointment}) {
    const dispatch = useDispatch();

    const user = useSelector(state => state.CommonReducer.user);
    const appointmentForm = useSelector(state => state.CommonReducer.forms && state.CommonReducer.forms.appointmentForm);
    const selectedAppointment = useSelector(state => state.AppointmentReducer.appointment);
    const commonActions = bindActionCreators(commonActionsImp, dispatch);
    const appointmentActions = bindActionCreators(appointmentActionsImp, dispatch);

    function getCustomerNumberForCallback() {
        return isMyAppointment ? null : appointmentForm?.data?.customerNumber;
    }

    function isReadonly(appointment, isCreation) {
        if (isCreation) return false;
        return !(appointment.assignee === user.email && appointment.status === 0);

    }

    useEffect(() => {
        return () => {
            commonActions.clearStoreSelected();
            if (appointmentForm) {
                commonActions.cancelFormEditing(appointmentForm.id);
            }
        };
    }, []);

    function onSaveClick() {
        appointmentActions.saveAppointment(
            appointmentForm,
            isCreation,
            getCustomerNumberForCallback(),
            callback
        );
    }

    function onSaveAndCreateClick() {
        appointmentActions.saveAppointment(
            appointmentForm,
            isCreation,
            getCustomerNumberForCallback(),
            callback,
            true
        );
    }

    function onCancelClick() {
        commonActions.cancelFormEditing(appointmentForm.id, callback);
    }

    function onReopenClick() {
        appointmentActions.reopenAppointment(
            appointmentForm.data.id,
            getCustomerNumberForCallback(),
            callback
        );
    }

    function onFieldChange(field, value) {
        commonActions.changeMultiFormField(appointmentForm.id, field, value);
    }

    function customerSearchOnChange(customer) {
        onFieldChange('customerNumber', customer.customerNumber);
        onFieldChange('customerName', customer.name);
    }

    if (!appointmentForm || (!isCreation && !selectedAppointment)) {
        return null;
    }

    const appointment = appointmentForm.data || {};

    const isCompleted = (selectedAppointment && selectedAppointment.isCompleted) || false;
    const readonly = selectedAppointment && isReadonly(selectedAppointment, isCreation);
    const assignee = isCreation
        ? { name: user.name || '', email: user.email }
        : { name: appointment.assigneeName || appointment.assignee, email: appointment.assignee };

    const attributes = {
        readonly: readonly,
        appointment: appointment,
        isCompleted: isCompleted,
        onFieldChange: (field, value) => onFieldChange(field, value),
        onSaveClick: onSaveClick,
        onCancelClick: onCancelClick,
        onReopenClick: () => onReopenClick(),
        customerSearchOnChange: (customer) => customerSearchOnChange(customer),
        showReopenButton: readonly && isCompleted,
        assignee: assignee,
        isCreation: isCreation,
        onSaveAndCreateClick: () => onSaveAndCreateClick(),
        width: appointmentFormWidth,
        hideButtons: hideButtons
    };

    return (
            <AppointmentForm {...attributes} />
    );
}

export default AppointmentFormContainer;